import React, { useState } from "react"
import ProfileSettingsCard from "./ProfileSettingsCard"
import AccountTypeCard from "./AccountTypeCard"
import CustomerSupportCard from "./CustomerSupportCard"
import DeleteAccountCard from "./DeleteAccountCard"
import BillingDetailsCard from "../BillingDetails/BillingDetailsCard.jsx"
import AldooTransferBanner from "@components/AldooTransferBanner"

const Profile = () => {
  const [expandedCard, setExpandedCard] = useState("accountType")

  return (
  <div
    className="w-full flex flex-col xl:flex-row gap-[30px] xl:gap-[20px] pb-[200px] items-center xl:items-start justify-center"
  >
    <div className="w-full max-w-[554px] flex flex-col items-center xl:items-end gap-8 xl:gap-5">
      <AldooTransferBanner placement="profile" />

      <AccountTypeCard
        isExpanded={expandedCard === "accountType"}
        onToggle={() => setExpandedCard(expandedCard === "accountType" ? null : "accountType")}
      />
      <ProfileSettingsCard
        isExpanded={expandedCard === "profileSettings"}
        onToggle={() => setExpandedCard(expandedCard === "profileSettings" ? null : "profileSettings")}
      />
      <BillingDetailsCard
        isExpanded={expandedCard === "billingDetails"}
        onToggle={() => setExpandedCard(expandedCard === "billingDetails" ? null : "billingDetails")}
      />
    </div>

    {/* These two cards are temporarily hidden */}
    {/* <div className="w-full xl:w-1/2 max-w-[554px] flex flex-col items-center xl:items-start gap-[30px] xl:gap-[20px]">
      <CustomerSupportCard />
      <DeleteAccountCard />
    </div> */}
  </div>
  )
}

export default Profile
